// ContactSection.jsx
import React from 'react';
import './ContactSection.css';
import { Card, CardContent } from './ui/card';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { mockContactInfo } from './mock';

const ContactSection = () => {
  const contactItems = [
    { icon: Phone, label: "Phone", value: mockContactInfo.phone, href: `tel:${mockContactInfo.phone}` },
    { icon: Mail, label: "Email", value: mockContactInfo.email, href: `mailto:${mockContactInfo.email}` },
    { icon: MapPin, label: "Address", value: mockContactInfo.address, href: "#" },
    { icon: Clock, label: "Hours", value: mockContactInfo.hours, href: "#" }
  ];

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <div className="contact-header">
          <div className="contact-badge">Contact Us</div>
          <h2 className="contact-title">
            Ready to Get
            <span className="contact-highlight"> Started?</span>
          </h2>
          <p className="contact-subtitle">
            Reach out to our expert team and experience the difference professional technical support can make for your business.
          </p>
        </div>

        <div className="contact-grid">
          {contactItems.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <Card key={index} className="contact-card">
                <CardContent className="contact-card-content">
                  <div className="contact-icon-wrapper">
                    <IconComponent className="contact-icon" />
                  </div>
                  <h3 className="contact-label">{item.label}</h3>
                  {item.href !== "#" ? (
                    <a href={item.href} className="contact-link">{item.value}</a>
                  ) : (
                    <p className="contact-value">{item.value}</p>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="contact-cta">
          <Card className="contact-cta-card">
            <CardContent className="contact-cta-content">
              <h3 className="cta-title">Need Immediate Assistance?</h3>
              <p className="cta-description">
                Our technical support team is standing by 24/7 to help resolve your issues quickly and efficiently.
              </p>
              <div className="cta-buttons">
                <a href={`tel:${mockContactInfo.phone}`} className="cta-button call">
                  <Phone className="cta-icon" />
                  Call Now: {mockContactInfo.phone}
                </a>
                <a href={`mailto:${mockContactInfo.email}`} className="cta-button email">
                  <Mail className="cta-icon" />
                  Email Support
                </a>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
